import get from 'lodash.get';
import { GuidService } from 'ui-components/services/guid-service';

import { baseReducer as BaseReducer } from '../../store/core/base-reducer';
import { JobPipelineService } from '../../services/job-pipeline-service';

import * as Actions from './job-pipeline.actions';

const initialState = {
  jobIdtoJobMap: {},
  lastAddedJobId: '',
};

const updateJobById = (state, jobId, updateProperties) => {
  const { jobIdtoJobMap } = state;
  const currentJob = jobIdtoJobMap[jobId];
  if (!currentJob) {
    return state;
  }
  return {
    ...state,
    jobIdtoJobMap: {
      ...jobIdtoJobMap,
      [jobId]: {
        ...currentJob,
        ...updateProperties,
      },
    },
  };
};

const getNewJobId = (state) => {
  let jobId = GuidService.newGuid();
  while (Object.keys(state.jobIdtoJobMap).indexOf(jobId) !== -1) {
    jobId = GuidService.newGuid();
  }
  return jobId;
};

const getSendJobToNewIndex = (indexFunction) => {
  return (state, { jobId }) => {
    const { jobIdtoJobMap } = state;
    const job = jobIdtoJobMap[jobId];
    if (!job) {
      return state;
    }
    const { currentPipelineIndex } = job;
    return updateJobById(state, jobId, {
      currentPipelineIndex: indexFunction(currentPipelineIndex),
    });
  };
};

const actionHandlerMap = {
  [Actions.START_JOB_PIPELINE]: (state, { jobId, pipelineId, jobData = {} }) => {
    const generatedJobId = jobId || getNewJobId(state);
    const { jobIdtoJobMap } = state;
    const pipelineData = JobPipelineService.getPipelineById(pipelineId);
    if (!pipelineData) {
      return {
        ...state,
        lastAddedJobId: undefined,
      };
    }
    const initialData = get(pipelineData, 'initialData', {});
    const mergedData = {
      ...initialData,
      ...jobData,
    };
    return {
      ...state,
      jobIdtoJobMap: {
        ...jobIdtoJobMap,
        [generatedJobId]: {
          id: generatedJobId,
          pipelineId,
          data: mergedData,
          currentPipelineIndex: 0,
        },
      },
      lastAddedJobId: generatedJobId,
    };
  },
  [Actions.UPDATE_JOB]: (state, { jobId, jobData }) => {
    const currentJobData = get(state, `jobIdtoJobMap[${jobId}].data`, {});
    return updateJobById(state, jobId, {
      data: { ...currentJobData, ...jobData },
    });
  },
  [Actions.DELETE_JOB]: (state, { jobId }) => {
    const { jobIdtoJobMap } = state;
    const newMap = { ...jobIdtoJobMap };
    delete newMap[jobId];
    return {
      ...state,
      jobIdtoJobMap: newMap,
    };
  },
  [Actions.GO_FORWARD_ON_JOB]: getSendJobToNewIndex((index) => index + 1),
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './job-pipeline.reducer.metadata';
